import { Skeleton, TableCell as MuiTableCell } from '@mui/material';
import { styled } from '@mui/styles';

interface TableSkeletonProps {
  columns: any[];
  rowCount?: number;
}

export const TableSkeleton = ({
  columns,
  rowCount = 7,
}: TableSkeletonProps) => {
  return (
    <>
      {Array.from({ length: rowCount }).map((_, index) => (
        <tr key={`skeleton-${index}`} data-testid={`table-skeleton-${index}`}>
          {columns.map((_, colIndex) => (
            <TableCell key={`skeleton-cell-${colIndex}`}>
              <Skeleton variant="text" height={24} />
            </TableCell>
          ))}
        </tr>
      ))}
    </>
  );
};

const TableCell = styled(MuiTableCell)(() => ({
  padding: '1rem 1.333rem',
  fontSize: 16,
  lineHeight: '20px',
  fontWeight: 400,
  borderBottomWidth: '1px',
}));
